export const RUNDOWN_START_TIME = 'RUNDOWN_START_TIME'
export const CREATED_NEW_OLD = 'CREATED_NEW_OLD'
export const CREATED_OLD_NEW = 'CREATED_OLD_NEW'
export const ALPHABETICAL = 'ALPHABETICAL'
export const RUNDOWN_ARCHIVED_AT = 'RUNDOWN_ARCHIVED_AT'
